import React, { SetStateAction } from 'react';

import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import { CustomersItem } from '@clients/customersClient';
import ControlTypeForm from '@pages/accountDetail/tabs/controls/addControls/ControlTypeForm';

interface ControlTypeModalProps {
    controlTypeModalOpen: boolean;
    setControlTypeModalOpen: React.Dispatch<SetStateAction<boolean>>;
    customers: CustomersItem[];
}
const ControlTypeModal = ({
    controlTypeModalOpen,
    setControlTypeModalOpen,
    customers,
}: ControlTypeModalProps) => {
    return (
        <PDialog
            open={controlTypeModalOpen}
            dialogTitle={
                <FormattedMessage
                    id="ControlTypeModal.title"
                    defaultMessage="What would you like to add the control to?"
                />
            }
            dialogSubtitle={
                <FormattedMessage
                    id="ControlTypeModal.selectType"
                    defaultMessage="Please select a control type below"
                />
            }
            onClose={() => setControlTypeModalOpen(false)}>
            <ControlTypeForm
                customers={customers}
                setControlTypeModalOpen={setControlTypeModalOpen}
            />
        </PDialog>
    );
};

export default ControlTypeModal;
